<div class="nav flex flex-row justify-content-between align-items-center col-12 md:col sm:col-3">
  <div class="flex flex-row align-content-center justify-content-start">
    <p-button class="icon-btn-drawer" [outlined]="true" (onClick)="openMenu()">
      @if(visible || adminDrawer){
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none">
          <path d="M16.5 16V8L12.5 12L16.5 16ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM8 19V5H5V19H8ZM10 19H19V5H10V19Z" fill="white"/>
        </svg>
      }@else if(!visible || !adminDrawer){
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none">
          <path d="M5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5ZM8 19V5H5V19H8ZM10 19H19V5H10V19ZM12.5 16L16.5 12L12.5 8V16Z" fill="white"/>
        </svg>
      }
    </p-button>
    <a [routerLink]="['/home']">
      <img src="/assets/img/logoTotalCashNav.svg" alt="">
    </a>
  </div>
  
  <div class="flex flex-row align-content-center justify-content-end mb-2">
    <p-button (click)="menu.toggle($event)" class="icon-btn" size="small" icon="pi pi-cog" aria-label="config"/>
    <p-menu #menu [model]="itemsConfig" [popup]="true">
      <ng-template #item let-item>
        <div [routerLink]="item.routerLink" class="p-2">
          <span>{{ item.label }}</span>
        </div>
      </ng-template>
    </p-menu>
    <p-button class="icon-btn mr-0 md:mr-5 sm:mr-5" (onClick)="menuProfile.toggle($event)" icon="pi pi-user" size="small"></p-button>
    <p-tieredmenu #menuProfile [model]="itemsProfile" [popup]="true">
      <ng-template #item let-item>
        <div class="p-2">
          @if (item.state?.flag) {
            <img
              [src]="item.state.flag"
              width="20"
              height="14"
            />
          }@else{
            <span [class]="item.icon"></span>
          }
          <span class="ml-2">{{ item.label }}</span>
        </div>
      </ng-template>
    </p-tieredmenu>
  </div>
</div>

<div>
  <p-drawer [(visible)]="adminDrawer" [style]="{ 'top': '2.5rem' }">
    <ng-template #headless>
      <p-menu [model]="items"></p-menu>
    </ng-template>
  </p-drawer>
</div>

<div class="flex flex-row h-full">
  @if (visible) {
    <div class="mt-2">
      <p-tieredmenu [model]="items"></p-tieredmenu>
    </div>
  }
  <div class="flex-1 content-area" [ngClass]="{ 'disabled-area': adminDrawer }">
    @if (adminDrawer) {
      <div class="overlay"></div>
    }
    <router-outlet></router-outlet>
  </div>
</div>
